var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArgentina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 6.10352e-05C12.0709 6.10352e-05 5.21962 4.61451 1.98462 11.3044H38.0155C34.7806 4.61451 27.9292 6.10352e-05 20.0001 6.10352e-05V6.10352e-05Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 40.0001C27.9292 40.0001 34.7805 35.3857 38.0155 28.6957H1.98462C5.21962 35.3857 12.0709 40.0001 20.0001 40.0001Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9777 20L23.5351 21.149L24.8358 23.5146L22.1835 23.0071L21.8474 25.6865L20 23.7159L18.1525 25.6865L17.8164 23.0071L15.1641 23.5145L16.4647 21.1489L14.0222 20L16.4648 18.851L15.1641 16.4856L17.8164 16.9929L18.1525 14.3135L20 16.2842L21.8475 14.3135L22.1835 16.9929L24.8359 16.4856L23.5352 18.8511L25.9777 20Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgentina);
export default __webpack_public_path__ + "static/media/argentina.db7be034814a7ce8129bdc20bc375f17.svg";
export { ForwardRef as ReactComponent };